import { render, staticRenderFns } from "./CampaignPermissions.vue?vue&type=template&id=32bb214e&"
import script from "./CampaignPermissions.vue?vue&type=script&lang=ts&"
export * from "./CampaignPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports